import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';

const RequireAuth = ({ children }) => {
	const { session, user, verifyUser } = useUserStore();
	const location = useLocation();

	useEffect(() => {
		if (!user && session) {
			verifyUser();
		}
	}, [user, session]);

	if (
		(!user && isEmpty(session)) ||
		(user && isEmpty(session)) ||
		(!user && (!session.userId || !session.id))
	) {
		// Redirect them to the /login page, but save the current location they were
		// trying to go to when they were redirected. This allows us to send them
		// along to that page after they login, which is a nicer user experience
		// than dropping them off on the home page.
		return <Navigate to="/login" state={{ from: location }} replace />;
	} else if (!user && !isEmpty(session)) {
		// show loader while verifying and loading user data
		return (
			<div className="fixed top-0 left-0 z-50 w-full h-full bg-white opacity-75">
				<div className="mt-[50vh] flex items-center justify-center">
					<div
						className="inline-block h-6 w-6 animate-spin rounded-full border-[3px] border-current border-t-transparent text-primary-600"
						role="status"
						aria-label="loading"
					>
						<span className="sr-only">Loading...</span>
					</div>
				</div>
			</div>
		);
	}

	return children;
};

RequireAuth.propTypes = {
	children: PropTypes.element,
};

export default RequireAuth;
